import type {Brand} from '@Components/mystuff-brands/brand-kits.types';
import {BrandKitSource} from '@Components/mystuff-brands/brand-kits.types';
import {useBrandKitsFromStore} from '@Hooks/brands/useBrandKitsFromStore';
import {useActiveBrandId} from '@Hooks/brands/useActiveBrandId';

export const useSortedBrandKitsFromStore = (): Brand[] => {
  const brands = useBrandKitsFromStore();
  const activeBrandId = useActiveBrandId();
  const activeBrandKit: Brand[] = [];
  const halloweenBrandKit: Brand[] = [];
  const otherBrandKits: Brand[] = [];

  brands.forEach((brand) => {
    if (brand.brandId === activeBrandId) {
      activeBrandKit.push(brand);
    } else if (brand.source === BrandKitSource.HALLOWEEN_PROMOTION) {
      halloweenBrandKit.push(brand);
    } else {
      otherBrandKits.push(brand);
    }
  });

  return [...activeBrandKit, ...halloweenBrandKit, ...otherBrandKits];
};
